import { render, staticRenderFns } from "./OfferKzBx.vue?vue&type=template&id=da8a72a2&"
import script from "./OfferKzBx.vue?vue&type=script&lang=js&"
export * from "./OfferKzBx.vue?vue&type=script&lang=js&"
import style0 from "./OfferKzBx.vue?vue&type=style&index=0&id=da8a72a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports